module.exports={
  "downloadData": "Download data",
  "featuredLayers": "Featured layers",
  "latestUpdate": "Latest update",
  "visibility": "Visibility",
  "fromZoomLevel": "From zoom level {level}",
  "userLayers": "User Layers",
  "additionalLayers": "Additional layers"
}
